import { Field } from 'react-final-form';

import { FormColumn } from '../UI/Form/FormColumn/FormColumn';
import { FormEmptyField } from '../UI/Form/FormEmptyField/FormEmptyField';
import { FormInput } from '../UI/Form/FormInput/FormInput';
import { FormRow } from '../UI/Form/FormRow/FormRow';
import {
  StripeCardDetailsFields,
  StripeFieldOptions,
} from './stripeCardDetailsForm.models';
import { useStripeCardDetailsForm } from './stripeCardDetailsForm.hooks';

import { customStyles } from './StripeInputWrapper.styles';
import { CardNumber } from './Fields/CardNumber/CardNumber';
import { CardExpiry } from './Fields/CardExpiry/CardExpiry';
import { CardCvc } from './Fields/CardCvc/CardCvc';
import { CustomComponent } from '../../models/types/CustomComponent';

const StripeCardDetailsModalForm = ({ disabled }: CustomComponent) => {
  const { changeFocusState, onChangeValue, isLabelActive, getFieldError } =
    useStripeCardDetailsForm();

  const options: StripeFieldOptions = {
    disabled,
    style: {
      ...customStyles,
    },
  };

  return (
    <div>
      <FormColumn>
        <FormRow isSubRow>
          <Field
            component={FormInput}
            inputId="card-details-card-holder-name"
            disabled={disabled}
            autoComplete="off"
            autoCorrect="off"
            name={StripeCardDetailsFields.CardHolderName}
          />
          <CardNumber
            name={StripeCardDetailsFields.CardNumber}
            changeFocusState={changeFocusState}
            isLabelActive={isLabelActive(StripeCardDetailsFields.CardNumber)}
            onChange={onChangeValue}
            disabled={disabled}
            options={options}
            error={getFieldError(StripeCardDetailsFields.CardNumber)}
          />
        </FormRow>
        <FormRow isSubRow>
          <FormRow isSubRow>
            <CardExpiry
              name={StripeCardDetailsFields.CardExpiration}
              changeFocusState={changeFocusState}
              isLabelActive={isLabelActive(
                StripeCardDetailsFields.CardExpiration,
              )}
              onChange={onChangeValue}
              disabled={disabled}
              options={options}
              error={getFieldError(StripeCardDetailsFields.CardExpiration)}
            />
            <CardCvc
              name={StripeCardDetailsFields.Cvc}
              changeFocusState={changeFocusState}
              isLabelActive={isLabelActive(StripeCardDetailsFields.Cvc)}
              onChange={onChangeValue}
              disabled={disabled}
              options={options}
              error={getFieldError(StripeCardDetailsFields.Cvc)}
            />
          </FormRow>
          <FormEmptyField />
        </FormRow>
      </FormColumn>
    </div>
  );
};

export default StripeCardDetailsModalForm;
